import { render, staticRenderFns } from "./ButtonDownloadMaterial.vue?vue&type=template&id=593d78e8&scoped=true"
import script from "./ButtonDownloadMaterial.vue?vue&type=script&lang=js"
export * from "./ButtonDownloadMaterial.vue?vue&type=script&lang=js"
import style0 from "./ButtonDownloadMaterial.vue?vue&type=style&index=0&id=593d78e8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "593d78e8",
  null
  
)

export default component.exports